import React, {Component} from "react";
import Helmet from "react-helmet";
import a5757 from "../../../static/favicons/apple-icon-57x57.png"
import a6060 from "../../../static/favicons/apple-icon-60x60.png"
import i1616 from "../../../static/favicons/favicon-16x16.png";
import a7272 from "../../../static/favicons/apple-icon-72x72.png";
import a7676 from "../../../static/favicons/apple-icon-76x76.png"
import a114114 from "../../../static/favicons/apple-icon-114x114.png";
import a120120 from "../../../static/favicons/apple-icon-120x120.png";
import a144144 from "../../../static/favicons/apple-icon-144x144.png";
import a152 from "../../../static/favicons/apple-icon-144x144.png";
import a180 from "../../../static/favicons/apple-icon-180x180.png";
import i192 from "../../../static/favicons/android-icon-192x192.png";
import i32 from "../../../static/favicons/favicon-32x32.png";
import i96 from "../../../static/favicons/favicon-96x96.png";
import msicon from "../../../static/favicons/ms-icon-144x144.png";

class SEO extends Component {
    render() {
        return (
          <Helmet>
              <meta charset="utf-8"/>
              <meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1"/>
              <meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1"/>
              <meta property="og:locale" content="en_US"/>
              <meta property="og:type" content="website"/>
              <meta name="google" content="notranslate"/>
              <meta name="language" content="en_EN"/>
              <meta name="robots" content="NOODP"/>
              <meta name="msnbot" content="NOODP"/>
              <meta name="author" content="Devise Interactive"/>
              <meta name="robots" content="index, follow"/>
              <meta name="revisit-after" content="15 days"/>
              <meta name="distribution" content="web"/>
              <meta name="copyright" content="H & N Group 2018"/>
              <link rel="author" href="https://plus.google.com/108262689399811704532"/>
              <meta name="twitter:card" content="summary"/>
              <meta name="distribution" content="web"/>


              <title>H & N Group | Wholesale Seafood</title>
              <meta name="description"
                    content="Since 1981, we've been a leader in fresh and frozen seafood. We are an advocate for safety, innovation and sustainability within the seafood industry."/>
              <meta name="keywords"
                    content="H & N Group, H & N Food Co., hnn Group, Hnn Food Co., market, fresh fish, frozen fish, sea products, wholesale, north pacific sourcing, fish business, sea floor, importing, exporting, trading, sales, fish stocks, west coast, deliver, warehouse, shipment, pacific, seafood, bulk"/>
              <meta property="og:title" content="H & N Group | Wholesale Seafood"/>
              <meta property="og:image" content="http://hnfoods.com/wp-content/uploads/2018/02/hn-og.jpg"/>
              <meta property="og:description"
                    content="Since 1981, weíve been a leader in fresh and frozen seafood. We are an advocate for safety, innovation and sustainability within the seafood industry."/>
              <meta property="og:site_name" content="H & N Group | Wholesale Seafood"/>
              <meta property="og:url" content="http://hnnfoods.com/"/>
              <link rel="canonical" href="http://hnfoods.com/"/>
              <meta name="twitter:url" content="http://hnfoods.com/"/>
              <meta name="twitter:title" content="H & N Group | Wholesale Seafood"/>
              <meta name="twitter:description"
                    content="Since 1981, weíve been a leader in fresh and frozen seafood. We are an advocate for safety, innovation and sustainability within the seafood industry."/>
              <meta name="twitter:image"
                    content="http://hnfoods.com/wp-content/uploads/2018/02/hn-og.jpg"/>


              <link rel="apple-touch-icon" sizes="57x57" href={a5757}/>
              <link rel="apple-touch-icon" sizes="60x60" href={a6060}/>
              <link rel="apple-touch-icon" sizes="72x72" href={a7272}/>
              <link rel="apple-touch-icon" sizes="76x76" href={a7676}/>
              <link rel="apple-touch-icon" sizes="114x114" href={a114114}/>
              <link rel="apple-touch-icon" sizes="120x120" href={a120120}/>
              <link rel="apple-touch-icon" sizes="144x144" href={a144144}/>
              <link rel="apple-touch-icon" sizes="152x152" href={a152}/>
              <link rel="apple-touch-icon" sizes="180x180" href={a180}/>
              <link rel="icon" type="image/png" sizes="192x192" href={i192}/>
              <link rel="icon" type="image/png" sizes="32x32" href={i32}/>
              <link rel="icon" type="image/png" sizes="96x96" href={i96}/>
              <link rel="icon" type="image/png" sizes="16x16" href={i1616}/>
              {/*<link rel="manifest" href={manifest}/>*/}
              <meta name="msapplication-TileColor" content="#ffffff"/>
              <meta name="msapplication-TileImage" content={msicon}/>
              <meta name="theme-color" content="#ffffff"/>

              <link href="https://use.fontawesome.com/releases/v5.0.4/css/all.css" rel="stylesheet"/>
              <link rel="stylesheet" type="text/css" charset="UTF-8"
                    href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"/>
              <link rel="stylesheet" type="text/css"
                    href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"/>
          </Helmet>
        )
    }
}

export default SEO;


// WEBPACK FOOTER //
// ./src/components/SEO/SEO.js